import isEmpty from 'lodash-es/isEmpty'
import mapValues from 'lodash-es/mapValues'
import omitBy from 'lodash-es/omitBy'

import { ILocationParams } from '../../reducers/reactRouterLocation'
import { encodeLocationParam } from './format'

const URL_SECURITY_SANITIZE_REGEXP = /<|>|'|"/g
const UNDESIRABLE_CHARS_REGEXP = /^\\/g
const CONSECUTIVE_SPACES_REGEXP = / {2,}/g

export const securitySanitizeString = (value: string) => {
  return (
    value
      .replace(UNDESIRABLE_CHARS_REGEXP, '')
      // only keeps part of string preceding any forbidden characters
      .split(URL_SECURITY_SANITIZE_REGEXP)[0]
      // consecutive spaces may be causing server side issues
      .replace(CONSECUTIVE_SPACES_REGEXP, ' ')
      .trim()
  )
}

export const sanitizeQueryParams = (
  params: ILocationParams
): ILocationParams => {
  return mapValues(omitBy(params, isEmpty), value =>
    securitySanitizeString(value || '')
  )
}

export const sanitizeLocationParam = (
  param: string,
  delimiter: string = ','
) => {
  const sanitizedParam = securitySanitizeString(param)
    .split(delimiter)
    .map(encodeLocationParam)
    .join('+')
  return sanitizedParam
}

export const getSanitizedUrl = securitySanitizeString
